import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export interface BreadcrumbItem {
  label: string;
  to?: string;
}

// Arriba de toda página que cuelgue de una jerarquía (Proveedor > Club > Pista...), para no
// perderse al entrar varios niveles. El último elemento (la página actual) nunca es un enlace.
export function Breadcrumbs({ items }: { items: BreadcrumbItem[] }) {
  return (
    <nav className="flex flex-wrap items-center gap-1.5 text-sm">
      {items.map((item, i) => (
        <span key={i} className="flex items-center gap-1.5">
          {i > 0 && <ChevronRight className="h-3.5 w-3.5 text-ink-300" />}
          {item.to ? (
            <Link to={item.to} className="font-medium text-ink-400 transition-colors hover:text-brand-600 hover:underline">
              {item.label}
            </Link>
          ) : (
            <span className="font-medium text-ink-800">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}
